import {
  Store,
  ReducersMapObject,
  Middleware,
  compose,
  createStore,
  combineReducers,
  applyMiddleware,
  Reducer,
  AnyAction,
} from 'redux';
import isEmpty from 'lodash/isEmpty';

const loggerMiddleware = _store => next => (action) => {
  // eslint-disable-next-line no-console
  console.info('dispatching', action);
  const result = next(action);

  return result;
};

export class StoreManager {
  private store: Store | null = null;

  private loggerEnabled: boolean;

  private reducerMap: ReducersMapObject = {};

  private middleware: any[] = [];

  constructor({ logger = false } = {}) {
    this.loggerEnabled = logger;
  }

  registerReducers(reducerMap: ReducersMapObject): void {
    Object.entries(reducerMap).forEach(([name, reducer]) => {
      this.reducerMap[name] = reducer;
    });
  }

  registerMiddleware(middleware: Middleware[]): void {
    this.middleware.push(...middleware.map(mid => mid(this.store as Store)));
  }

  createRootReducer(): Reducer {
    const reducers = Object
      .keys(this.reducerMap)
      .reduce((result, key) => Object.assign(result, {
        [key]: this.reducerMap[key],
      }), { ...this.store?.getState() });

    if (isEmpty(reducers)) return state => state;

    return combineReducers(reducers as never);
  }

  createStore<T>(initialState = {}): Store<T> {
    const composeEnhancers = (
      typeof window === 'object' && (window as any).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
        ? (window as any).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({})
        : compose
    );
    const enhancer = () => (
      (next: Function) => (action: AnyAction) => (
        (compose as any)(...this.middleware)(next)(action)
      )
    );

    this.store = createStore(this.createRootReducer(), initialState, composeEnhancers(
      this.loggerEnabled ? applyMiddleware(enhancer, loggerMiddleware) : applyMiddleware(enhancer),
    ));

    return this.store;
  }

  refreshStore(): void {
    if (this.store) {
      this.store.replaceReducer(this.createRootReducer());
    }
  }

  isCreated(): boolean {
    return this.store !== null;
  }

  dispatch(action: (payload: any) => AnyAction, payload: any) {
    this.store?.dispatch(action(payload));
  }
}
